import { motion } from "framer-motion";
import { MaskText, Reveal } from "./Reveal";

const WinkSmiley = () => (
  <motion.svg
    viewBox="0 0 100 100"
    aria-hidden
    data-testid="footer-smiley"
    className="h-10 w-10 md:h-12 md:w-12 shrink-0"
    animate={{ rotate: 360 }}
    transition={{ repeat: Infinity, duration: 6, ease: "linear" }}
  >
    <circle cx="50" cy="50" r="49" fill="#0047FF" />
    {/* open left eye */}
    <ellipse cx="35" cy="39" rx="4.6" ry="10" fill="#FFD400" />
    {/* winking right eye */}
    <path
      d="M56 41 Q65 33 74 41"
      stroke="#FFD400"
      strokeWidth="6"
      fill="none"
      strokeLinecap="round"
    />
    {/* smile */}
    <path
      d="M26 58 Q50 86 74 58"
      stroke="#FFD400"
      strokeWidth="8.5"
      fill="none"
      strokeLinecap="round"
    />
  </motion.svg>
);

const SOCIALS = [
  { label: "Instagram", href: "https://instagram.com/modernmindearth" },
];

const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative grain bg-[#0a0a0a] overflow-hidden pt-28 md:pt-40 pb-10"
    >
      <div className="relative z-10 px-6 md:px-12 lg:px-16">
        <span className="label text-white/40">(Let's build)</span>
        <MaskText
          lines={["Let's make", "your idea real."]}
          className="tight font-extrabold text-white text-4xl sm:text-5xl md:text-7xl mt-4 mb-14"
        />

        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-10 border-t border-white/15 pt-10">
          <div>
            <p className="label text-white/40 mb-3">Start here</p>
            <a
              href="mailto:amber@modernmindearth.com"
              data-testid="contact-email-link"
              className="sweep text-white text-3xl md:text-5xl font-extrabold tracking-tight"
            >
              Email us
            </a>
          </div>

          <div
            data-testid="contact-social-links"
            className="flex flex-wrap gap-x-8 gap-y-3"
          >
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`social-${s.label.toLowerCase().replace(/\W/g, "")}`}
                className="sweep label text-white/70 hover:text-white"
              >
                {s.label}
              </a>
            ))}
          </div>
        </Reveal>

        <div className="mt-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 md:gap-6 border-t border-white/10 pt-5">
          <div className="flex items-center gap-3">
            <WinkSmiley />
            <span className="text-xs text-white font-extrabold tracking-tight">STUDIO FRANCO</span>
          </div>
          <p className="label text-[10px] text-white/35">
            © {new Date().getFullYear()} — Function with feeling
          </p>
          <p className="label text-[10px] text-white/35">Built builder-to-builder</p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
